import {NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {RouteReuseStrategy} from '@angular/router';

import {IonicModule, IonicRouteStrategy} from '@ionic/angular';
// Capacitor plugins não precisam ser importados no módulo

import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import {FirebaseService} from './@shared/services/firebase.service';

@NgModule({ declarations: [AppComponent],
    bootstrap: [AppComponent], imports: [BrowserModule,
        IonicModule.forRoot(),
        AppRoutingModule], providers: [
        { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class AppModule {
    constructor(fireSrv: FirebaseService) {
        console.log('# AppModule');
        fireSrv.init();
    }
}
